/* Global alert for first-time reference save. Renders a FloatingAlert in bottom-right.
   Listens for a custom DOM event dispatched by useSavedReferences. */

import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FloatingAlert } from "@/components/ui/FloatingAlert";
import { RoutePath } from "@/routePaths";

export const SAVED_REF_ALERT_EVENT = "feedkiwi:saved-ref-alert";

export function SavedReferenceAlert() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener(SAVED_REF_ALERT_EVENT, handler);
    return () => window.removeEventListener(SAVED_REF_ALERT_EVENT, handler);
  }, []);

  const handleAction = useCallback(() => {
    navigate(`${RoutePath.Stats}?tab=saved-refs`);
  }, [navigate]);

  return (
    <FloatingAlert
      open={open}
      onOpenChange={setOpen}
      title="Reference saved!"
      description="Find all your saved references in the References tab on the Insights page."
      actionLabel="Go to References"
      onAction={handleAction}
    />
  );
}
